<rad-chip 
  class="rad-theme--light resource-chip"
  [appShadowDom]="shadowDomConfig"
  [attr.dismissible]="dismissible"
  (chipRemoved)="onChipRemoved()"
></rad-chip>

<!-- Hidden content container for popover (if needed) -->
<div #chipContent class="chip-hidden-content">
    <rad-popover 
        *ngIf="hasPopoverContent"
        position="top"
        class="chip-popover">
        <rad-icon 
            name="meatballMenu" 
            size="sm"
            style="cursor: pointer;">
        </rad-icon>
        <rad-popover-custom-content>
            <ng-content></ng-content>
        </rad-popover-custom-content>
    </rad-popover>
</div>

